export default function Main () {
    
    return (
        <>
        <section id="main">
            <div className="container-main">
            <h1>hi, I'm Dina.</h1>
               
                <p>I've lived in Spain for over 10 years as both auxiliar de conversación and autónoma. </p>
                <p>Need advice about navigating life in Spain? I'm here to help!</p>
                <div className="profile-round" style={{backgroundImage:"url(/img/photomain.jpg)",  backgroundSize: "contain"}}></div>
                
            </div>
        </section>
        </>
    )
}